import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorEvent, SuccessEvent } from '@progress/kendo-angular-upload';
import {
  LoaderService,
  MessageService,
  ValidationResult,
  ValidationResultService,
} from '@shared';

@Component({
  selector: 'app-importer',
  templateUrl: './importer.component.html',
  styleUrl: './importer.component.scss',
})
export class ImporterComponent {
  acceptedTypes =
    'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, application/vnd.ms-excel.addin.macroEnabled.12, application/vnd.oasis.opendocument.spreadsheet';

  @Output()
  success: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  importUrl!: string;

  @Input()
  multiple: boolean = false;

  uploadResults = new Map<string, string>();

  constructor(
    private loaderService: LoaderService,
    private messageService: MessageService,
    private validationResultService: ValidationResultService,
  ) {}

  onComplete(completeEvent: any) {
    if (
      Array.from(this.uploadResults.values()).every(
        (status) => status === 'success',
      )
    ) {
      this.success.emit(completeEvent);
    } else {
      this.messageService.error(
        `There was an error uploading the following files: ${Array.from(
          this.uploadResults.entries(),
        )
          .filter(([_, status]) => status === 'error')
          .map(([fileName]) => fileName)
          .join(', ')}`,
      );
    }
    this.loaderService.hide();
  }

  onSuccess(successEvent: SuccessEvent) {
    successEvent.files.forEach((f) => {
      const key = f.uid || f.name;
      this.uploadResults.set(key, 'success');
    });

    const validationResult = successEvent.response?.body as ValidationResult;
    if (validationResult?.errors?.length) {
      this.validationResultService.show(validationResult);
    }
  }

  onError(error: ErrorEvent) {
    error.files.forEach((f) => {
      const key = f.uid || f.name;
      this.uploadResults.set(key, 'error');
    });

    var validationErrors = (error?.response as unknown as HttpErrorResponse)
      .error;
    if (validationErrors) {
      this.validationResultService.show(validationErrors);
    }
  }

  beginUpload() {
    this.loaderService.show();
  }
}
